import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/bt-logo.svg")